import { createCrudApi } from 'src/shared/api/crudApi';
import { httpClient } from 'src/shared/api/httpClient';
import { API_PREFIX } from 'src/shared/constants';
import type {
  Service,
  ServiceCategory,
  ServiceCategoryListParams,
  ServiceCategoryPayload,
  ServiceListParams,
  ServicePayload,
  ServicePrice,
  ServiceUpdatePayload,
} from './types';

const servicesBase = `${API_PREFIX}/services`;
const categoriesBase = `${API_PREFIX}/service-categories`;

const serviceCrud = createCrudApi<
  Service,
  ServiceListParams,
  ServicePayload,
  ServiceUpdatePayload,
  number
>(servicesBase);

export const servicesApi = {
  ...serviceCrud,

  /** Every period the price has been at, newest first. Owner/manager only. */
  priceHistory: (id: number) =>
    httpClient.get<ServicePrice[]>(`${servicesBase}/${id}/price-history`),
};

export const serviceCategoriesApi = createCrudApi<
  ServiceCategory,
  ServiceCategoryListParams,
  ServiceCategoryPayload,
  ServiceCategoryPayload,
  number
>(categoriesBase);
